import { useEffect, useRef, useState, useParams, useCallback } from '../../common/common';
import useGetUserData from '../../secureAPI/GetUserData';
import { useErrorContext } from '../../context/ErrorContext';
import axiosJWT from '../../secureAPI/axiosJWT';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils.js';
import { showToast } from '../../Utils/toastUtils.js';
import * as XLSX from 'xlsx';
import Navigations from '../../common/useNavigation.js';


const MidViewSellerOrders = (type, orderType) => {

    const { users, userPlan, Remainuser, subUser } = useGetUserData();
    const { navigateDashboard } = Navigations();
    const [isLoading, setisLoading] = useState(false);
    const [orders, setOrders] = useState([]);
    const [filteredCategories, setFilteredCategories] = useState([]);
    const [open, setOpen] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [Selected, setSelected] = useState('');
    const [orderTypes, setOrderTypes] = useState([]);
    const [seacrh, setSearch] = useState('');
    const [filterDiv, setfilterDiv] = useState(false);

    // filters
    const [seacrhOrderId, setSearchOrderId] = useState('');
    const [seacrhBuyername, setSearchBuyername] = useState('');
    const [seacrhMinQty, setSearchMinQty] = useState(0);
    const [seacrhMaxQty, setSearchMaxQty] = useState('');
    const [seacrhMinAmt, setSearchMinAmt] = useState(0);
    const [seacrhMaxAmt, setSearchMaxAmt] = useState('');
    const [seacrhTodate, setSearchTodate] = useState('');
    const [seacrhFromdate, setSearchFromdate] = useState('');
    const [seacrhUpdateTodate, setSearchUpdateTodate] = useState('');
    const [seacrhUpdateFromdate, setSearchUpdateFromdate] = useState('');
    const [filteropen, setfilterOpen] = useState(false);
    const [filterSelected, setfilterSelected] = useState('');
    const [seacrhOrderType, setSearchOrderType] = useState(0);
    const [selectedRows, setSelectedRows] = useState([]);
    const [toggleCleared, setToggleCleared] = useState(false);
    const [lgShow1, setLgShow1] = useState(false);
    const [sheetdata, setSheetdata] = useState([]);

    const [usercustomfields, setusercustomfields] = useState([]);
    const [values, setValue] = useState();
    const [typevalues, settypeValue] = useState([]);

    useEffect(() => {
        const statusMap = {
            Confirmed: 2,
            OnHold: 3,
            Processing: 4,
            Processing: 4,
            Completed: 7,
            Delivered: 9,
        };

        const statusCode = statusMap[orderType];

        if (statusCode && orders?.length) {
            const filteredOrders = orders.filter(order => order?.order_status === statusCode);
            // console.log(filteredOrders); // optional debugging
            setFilteredCategories(filteredOrders);
            setSheetdata(filteredOrders);
        }
    }, [orderType, orders]);

    useEffect(() => {
        //  console.log('called useeffectsss');
        if (Array.isArray(users) && users.length > 0) {
            //   console.log('useEffect called, users:', users);
            logUserData();
        }
    }, [users]);

    const logUserData = () => {
        if (users?.length > 0) {
            const userTypes = users[0]['UserType'];
            const usertypeArray = typeof userTypes === 'string' ? userTypes.split(',').map(str => parseInt(str.trim())).filter(num => !isNaN(num)) : [];

            const hasOne = usertypeArray.includes(1);
            const hasTwo = usertypeArray.includes(2);
            if (type === 'buyer' && users[0]['IsPersonalDetils'] === 1 && (hasOne || (hasOne && hasTwo))) {
                navigateDashboard('buyer');
            }
            if (type === 'seller' && users[0]['IsPersonalDetils'] === 1 && (hasOne && hasTwo)) {

            }
            else {
                navigateDashboard('seller');
            }

        }
    };

    useEffect(() => {
        getOrdersType();
        getsellerOrders();
    }, []);

    useEffect(() => {
        const filtered_result_by_buyer_name = orders.filter((orders) => {
            return (
                orders.full_name.toLowerCase().match(seacrh.toLowerCase())
            );
        });
        setFilteredCategories(filtered_result_by_buyer_name);
        setSheetdata(filtered_result_by_buyer_name);
    }, [seacrh]);

    useEffect(() => {
        const filtered_result_by_order_id = orders.filter((orders) => {
            return (
                orders.order_unique_key.match(seacrhOrderId)
            );
        });
        setFilteredCategories(filtered_result_by_order_id);
        setSheetdata(filtered_result_by_order_id);
    }, [seacrhOrderId]);

    useEffect(() => {
        const filtered_result_buyer_name = orders.filter((orders) => {
            return (
                orders.full_name.toLowerCase().match(seacrhBuyername.toLowerCase())
            );
        });
        setFilteredCategories(filtered_result_buyer_name);
        setSheetdata(filtered_result_buyer_name);
    }, [seacrhBuyername]);

    useEffect(() => {
        const filtered_result_Qty = orders.filter((orders) => {
            return (
                orders.total_quantity > Math.min(seacrhMinQty) && orders.total_quantity < Math.min(seacrhMaxQty)
            );
        });
        setFilteredCategories(filtered_result_Qty);
        setSheetdata(filtered_result_Qty);
    }, [seacrhMinQty, seacrhMaxQty]);
    
    useEffect(() => {
        const filtered_result_amount = orders.filter((orders) => {
            return (
                orders.ammount > Math.min(seacrhMinAmt) && orders.ammount < Math.min(seacrhMaxAmt)
            );
        });
        setFilteredCategories(filtered_result_amount);
        setSheetdata(filtered_result_amount);
    }, [seacrhMinAmt, seacrhMaxAmt]);

    useEffect(() => {
        const filtered_result_order_date = orders.filter((orders) => {
            return (
                orders.order_created_date > seacrhTodate && orders.order_created_date < seacrhFromdate
            );
        });
        setFilteredCategories(filtered_result_order_date);
        setSheetdata(filtered_result_order_date);
    }, [seacrhTodate, seacrhFromdate]);

    useEffect(() => {
        const filtered_result_order_update_date = orders.filter((orders) => {
            return (
                orders.order_modified_date > seacrhUpdateTodate && orders.order_modified_date < seacrhUpdateFromdate
            );
        });
        setFilteredCategories(filtered_result_order_update_date);
        setSheetdata(filtered_result_order_update_date);
    }, [seacrhUpdateTodate, seacrhUpdateFromdate]);

    useEffect(() => {
        const filtered_result_order_type = orders.filter((orders) => {
            // console.log(orders?.order_status);
            // console.log(seacrhOrderType);
            return (
                orders?.order_status === seacrhOrderType
            );
        });
        setFilteredCategories(filtered_result_order_type);
        setSheetdata(filtered_result_order_type);
    }, [seacrhOrderType]);

    const handlemodalshow = () => {
        setLgShow1(true);
    }

    const handlemodalhide = () => {
        setLgShow1(false);
    }

    const exporttoExcelData = () => {
        var wb = XLSX.utils.book_new(),
            ws = XLSX.utils.json_to_sheet(sheetdata);
        XLSX.utils.book_append_sheet(wb, ws, 'Orders');
        XLSX.writeFile(wb, "Selzor_Orders.xlsx");
    }

    const handleupdateorderState = async (status_id) => {
        if (window.confirm(`Are you sure you want to change order status ?`)) {
            if (selectedRows === '' || selectedRows.length === 0) {
                showToast('Please select at least one order ', 'error');
            }
            else {
                StartLoading(setisLoading);
                setToggleCleared(!toggleCleared);
                updateorderStates(status_id);
            }
        }
    }

    const updateorderStates = async (status_id) => {
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/UpdateOrderStatus`, { status_id: status_id, update_id_array: selectedRows, }, { withCredentials: true })
                .then((res) => {
                    StopLoading(setisLoading);
                    if (res.data.success === 1) {
                        // console.log(res.data);
                        showToast(res.data.message, 'success');

                 
                        setSelectedRows([])
                        getsellerOrders();
                        setFilteredCategories([])
                    }
                    else if (res.data.success === 0) {
                        setToggleCleared(!toggleCleared);
                      
                        setSelectedRows([])
                        setFilteredCategories([])
                        showToast(res.data.message, 'error');
                    }
                })
                .catch((err) => {
                    StopLoading(setisLoading)
                    showToast('Something went wrong ! please try again ', 'error');
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to get Order Details, please try again later ", 'error');
        }
    }


                        

    const getsellerOrders = async () => {
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetSellerOrder`, { app: 0 }, { withCredentials: true })
                .then((res) => {
                    StopLoading(setisLoading)
                    if (res.data.success === 1) {
                        setOrders(res.data.data);
                        setFilteredCategories(res.data.data);
                        setSheetdata(res.data.data);
                    }
                    else if (res.data.success === 0) {
                        showToast(res.data.message, 'error');
                    }
                })
                .catch((err) => {
                    StopLoading(setisLoading)
                    showToast('Something went wrong ! please try again ', 'error');
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to get Order Details, please try again later ", 'error');
        }
    }

    const getOrdersType = async () => {
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetOrderstype`, {}, { withCredentials: true })
                .then((res) => {
                    StopLoading(setisLoading)
                    if (res.data.success === 1) {
                        // console.log(res.data.data);
                        setOrderTypes(res.data.data);
                    }
                    else if (res.data.success === 0) {
                        showToast(res.data.message, 'error');
                    }
                })
                .catch((err) => {
                    StopLoading(setisLoading)
                    showToast('Something went wrong ! please try again ', 'error');
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to get Order Details, please try again later ", 'error');
        }
    }

    const handleRowSelected = useCallback((state) => {
        // check condition
        const hasRestrictedStatus = state.selectedRows.some(
            (row) =>
                row.order_status == 9 ||
                row.order_status == 7 ||
                row.order_status == 6
        );

        if (hasRestrictedStatus) {
            // toast.warning("No change status");
            showToast('No change status !!! ', 'error');
        }
        else {
            setSelectedRows(state.selectedRows);
        }
    }, []);

    // ---------------------------//
    const handlenameChange = e => {
        const { name, value } = e.target;
        const { id } = e.target;
        setValue({ ...values, [name]: value });
        settypeValue({ ...typevalues, [name]: id });
    };

    const handleonchange = e => {
        setValue({ ...values, [e.target['name']]: e.target.files[0] });
    };

    const handleSubmit = e => {
        // console.log(typevalues);
        e.preventDefault();

        add_CustomFields(selectedRows);
    }


    const add_CustomFields = async (selectedRows) => {
        // console.log(selectedRows);
        // const order_id = selectedRows[0]['order_unique_key'];
        // const buyer_id = selectedRows[0]['buyer_id'];
        // var formData = new FormData();
        // formData.append("OrderID", order_id);
        // formData.append("BuyerID", buyer_id);

        // for (let i = 0; i < 50; i++) {
        //     const temp = 'values.customfield' + i;
        //     const templabeltype = 'typevalues.customfield' + i;
        //     if (eval(temp) === undefined || eval(temp) === null) {
        //         break;
        //     }
        //     formData.append('customfield' + i, eval(temp));
        //     console.log('typeofcustomfield' + i, eval(templabeltype));
        //     formData.append('typeofcustomfield' + i, eval(templabeltype));
        // }
        // console.log(formData);

        // setisLoading(true);
        // setisDisabled(true);
        // await axiosJWT.post(`${API__URL}/api/Addcustomfielddetails`, formData)
        //     .then((res) => {
        //         var result = JSON.parse(JSON.stringify(res));
        //         console.log(result.data);
        //         if (result.data.success === 1) {
        //             const msg = result.data.message;
        //             setisLoading(false);
        //             setisDisabled(false);
        //             toastifn(1, msg);
        //             handlemodalhide();


        //         }
        //         else {
        //             const msg = result.data.message;
        //             setisLoading(false);
        //             setisDisabled(false);
        //             toastifn(0, msg);
        //         }
        //     })
        //     .catch((err) => {
        //         console.log(err);
        //         setisLoading(false);
        //         msg = 'ops...Something went wrong ! please try after sometime ';
        //         toastifn(1, msg);
        //     });
    };

    
    return { users, userPlan, Remainuser, subUser, filteredCategories, orders, open, inputValue, Selected, orderTypes, seacrh, seacrhOrderId, seacrhBuyername, seacrhMinQty, seacrhMaxQty, seacrhMinAmt, seacrhMaxAmt, seacrhTodate, seacrhFromdate, seacrhUpdateTodate, seacrhUpdateFromdate, filteropen, filterSelected, seacrhOrderType, setSearchOrderId, setSearchBuyername, setSearchMinQty, setSearchMaxQty, setSearchMinAmt, setSearchMaxAmt, setSearchTodate, setSearchFromdate, setSearchUpdateTodate, setSearchUpdateFromdate, setfilterOpen, setfilterSelected, setSearchOrderType, setOpen, setInputValue, setSelected, setOrderTypes, setSearch, handleupdateorderState, lgShow1, setLgShow1, sheetdata, setSheetdata, handlemodalhide, usercustomfields, setusercustomfields, handlenameChange, handleonchange, exporttoExcelData, filterDiv, setfilterDiv, getsellerOrders, handleSubmit, handleRowSelected }
}

export default MidViewSellerOrders